import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastProvider } from "./contexts/ToastContext";
import HomePage from './pages/HomePage';
import GymManagementPage from './pages/GymManagementPage';
import NotFoundPage from './pages/NotFoundPage';
import ValentinePage from './pages/ValentinePage';
import { initGA, logPageView } from './utils/analytics';

// Google Analytics Measurement ID - Replace with your actual GA4 Measurement ID
const GA_MEASUREMENT_ID = 'G-9VTT7MMMSY'; // TODO: Replace with your GA4 ID

// Component to track page views
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics on app load
    initGA(GA_MEASUREMENT_ID);
  }, []);

  return (
    <ToastProvider>
      <Router>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gym-management" element={<GymManagementPage />} />
          <Route path="/valentine" element={<ValentinePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;
